<template>
    <div :class="{ 'authentication-required': true, 'light-theme': theme === 'light' }">
        <h3>Pre-Authorization Required</h3>
        <p>Please call <a href="tel:1-800-726-0003">1-800-726-0003</a> prior to attending your first session.</p>
    </div>
</template>

<script>
export default {
    props: {
        theme: {
            default: 'light'
        }
    },
    data () {
        return {

        }
    },
}
</script>
    
<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/mixins";

.authentication-required {
    background-color: #C7932C;
    padding: 16px 0;
    border-radius: 5px;
    text-align: center;

    @include md {
        padding: 16px 60px;
    }

    h3 {
        color: #ffffff;
        font-size: 14px;
        font-weight: 700;
        line-height: 1;
        margin-bottom: 8px;
    }

    p {
        color: #ffffff;
        font-size: 12px;

        a {
            font-weight: bold;
            font-family: Paralucent;
            color: #ffffff;
        }
    }

    &.light-theme {
        background-color: #FFFFFF;
        margin-bottom: 40px;

        h3,
        p {
            color: #0B3148;

            a {
                color: #0B3148;
            }
        }
    }
}
</style>